/* eslint-disable max-len */
const REVERSE_PROXY_LINK = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';
export const NOT_DEFINED = 'not specified';
export const PRODUCTS_COLLECTION_LOAD_COUNT = 45;
export const PLACEHOLDER = `${REVERSE_PROXY_LINK}/images/product-placeholder.svg`;
export const ERROR_ADD_PENNY_PRODUCT_MESSAGE =
  'The deal is complete, adding an extra discounted product is not possible. Please continue shopping from our regular menu.';
